import React from "react";
import Svg, { Path } from "react-native-svg";
import { TouchableOpacity } from "react-native";
import AppTheme from "../../AppTheme";

export default function CheckElementIcon({
  isSelected,
  style,
  onPress = () => {},
}) {
  return (
    <TouchableOpacity style={style} onPress={onPress}>
      {isSelected ? (
        <Svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            d="M8.08325 3.91675C8.40542 3.59458 8.40542 3.07225 8.08325 2.75008C7.76109 2.42792 7.23875 2.42792 6.91659 2.75008L4.16659 5.50008L3.08325 4.41675C2.76109 4.09458 2.23875 4.09458 1.91659 4.41675C1.59442 4.73891 1.59442 5.26125 1.91659 5.58342L3.57733 7.24416C3.90277 7.5696 4.4304 7.5696 4.75584 7.24416L8.08325 3.91675Z"
            fill="black"
            fill={AppTheme.almostBlack}
          />
        </Svg>
      ) : (
        <Svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <Path
            d="M4 0.234963C3.84976 0.234773 3.70563 0.294368 3.5994 0.400597C3.49317 0.506826 3.43358 0.650958 3.43377 0.801189L3.43457 3.43478L0.800975 3.43398C0.488257 3.43398 0.234748 3.68749 0.234748 4.00021C0.234748 4.31293 0.488257 4.56644 0.800975 4.56644L3.43457 4.56564L3.43377 7.19923C3.43377 7.51195 3.68728 7.76546 4 7.76546C4.31271 7.76546 4.56622 7.51195 4.56622 7.19923L4.56542 4.56564L7.19902 4.56644C7.40131 4.56644 7.58824 4.45851 7.68938 4.28332C7.79053 4.10813 7.79053 3.89229 7.68938 3.7171C7.58824 3.54191 7.40131 3.43398 7.19902 3.43398L4.56542 3.43478L4.56622 0.801189C4.56641 0.650959 4.50682 0.506826 4.40059 0.400597C4.29436 0.294368 4.15023 0.234773 4 0.234963Z"
            fill={AppTheme.almostBlack}
          />
        </Svg>
      )}
    </TouchableOpacity>
  );
}
